import React from "react";
import ResetPassword from "../components/ResetPassword/ResetPassword"; 
import Footer from "../components/Footer/Footer"; // ✅ Import Footer

const ResetPasswordPage = () => {
  return (
    <div className="flex flex-col justify-between min-h-screen bg-gray-100">
      {/* ✅ Reset Password Component */}
      <div className="flex justify-center items-center flex-grow">
        <ResetPassword />
      </div>

      {/* ✅ Footer added at the bottom */}
      <Footer />
    </div>
  );
};

export default ResetPasswordPage;
